import React, { useState } from 'react';

import { Branch } from 'src/components/GoogleMaps/GoogleMapsTypes';
import { useDeps } from 'src/hooks/useDeps';
import { GoogleMap } from 'src/components/GoogleMaps/GoogleMaps';
import { BranchLocationQueryProvider } from 'src/components/StoreLocator/BranchLocationQuery';
import { GoogleMapsApiProvider } from 'src/components/GoogleMaps/GoogleMapsApiProvider';
import { BranchFinder } from 'src/components/GoogleMaps/BranchFinder';

import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { TwoUp } from '../Layout/TwoUp';

export function BranchesLanding() {
    const { GOOGLE_MAPS_API_KEY } = useDeps().env;
    const [visibleBranches, setVisibleBranches] = useState<Branch[]>([]);

    function handleChange(result) {
        setVisibleBranches(result);
    }

    return (
        <>
            <Breadcrumbs breadcrumbs={[]} current="Stores" />

            <h1>Stores</h1>

            <p className="lede">
                Find your nearest Woodie's store by entering your address or using your current location
            </p>

            <BranchLocationQueryProvider>
                <GoogleMapsApiProvider apiKey={GOOGLE_MAPS_API_KEY} language="en" region="IE">
                    <TwoUp
                        left={
                            <BranchFinder visibleBranches={visibleBranches} visibleCount={20} onChange={handleChange} />
                        }
                        right={<GoogleMap visibleBranches={visibleBranches} />}
                    />
                </GoogleMapsApiProvider>
            </BranchLocationQueryProvider>
        </>
    );
}
